<!-- Top Navbar Area -->
<nav class="navbar top-navbar navbar-expand">
    <div class="collapse navbar-collapse" id="navbarSupportContent">
        <div class="responsive-burger-menu d-block d-lg-none" style="color: white;">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>
        <div *ngIf="!company">
            <span class="text-info">ADMIN</span>
        </div>
        <div class="container-company" *ngIf="company">
            <div class="company-popover-wrapper">
                <button
                type="button"
                class="btn btn-button button-company"
                style="color:white; font-weight: 900;"
                (click)="toggleCompanyPopover()"
                >
                <img
                    class="company-img"
                    [src]="company.companyLogo"
                    alt=""
                    *ngIf="company.companyLogo != templateSrc && !errorLoadImage"
                    (error)="errorLoadImage = true"
                />

                <span style="mix-blend-mode: difference;">
                    <i
                    class="fa fa-warehouse"
                    *ngIf="company.companyLogo == templateSrc || errorLoadImage"
                    ></i>
                    {{ company.alphanumericId }}
                </span>
                </button>

                <div *ngIf="showCompanyPopover" class="custom-popover">
                <p class="title"><em>Compañía actual</em></p>
                <div class="popover-custom-v1">
                    <p class="alphanumeric-id">{{ company?.alphanumericId }}</p>
                    <p class="company-name">{{ company?.companyName }}</p>
                    <p class="company-nit">NIT: <b>{{ company?.companyNIT }}</b></p>
                    <p class="link">
                    <a routerLink="/select-company" (click)="closeCompanyPopover()" class="clickeable">
                        CAMBIAR <i class="fa-solid fa-circle-right"></i>
                    </a>
                    </p>
                </div>
                </div>
            </div>
        </div>
        <ul class="navbar-nav right-nav align-items-center">
            <li class="nav-item message-box dropdown" *ngIf="company">
                <button class="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <div class="message-btn">
                        <i class='bx bx-calendar'></i>
                        <span class="badge bg-primary" *ngIf="left > 0">{{left > 3?'3+':left}}</span>
                    </div>
                </button>
                <div class="dropdown-menu">
                    <div class="dropdown-header d-flex justify-content-between align-items-center" *ngIf="left > 0">
                        <span class="title d-inline-block">{{left > 3?'3+':left}} Eventos Nuevos</span>
                        <!-- <span class="clear-all-btn d-inline-block">Clear All</span> -->
                    </div>
                    <div class="dropdown-body" style="padding-top: 0; padding-bottom: 0; max-height: 300px; overflow-y: auto;">
                        <a [href]="getRediction(event)" [ngClass]="!event.showed?'bg-notification':''" *ngFor="let event of events; let i = index" class="dropdown-item d-flex align-items-center">
                            <div class="figure">
                                <i [ngClass]="(!event.showed?'cadetblue-icon ':'gray-icon ') + getIconForEvent(event)"
                                class="fa notification"></i>
                            </div>
                            <div class="content d-flex justify-content-between align-items-center relative">
                                <div class="text">
                                    <span class="d-block">{{event.application.newCompany.name}}</span>
                                    <p class="sub-text mb-0">{{event.description}}</p>
                                    <p class="sub-text mb-0" style="font-size: 0.7em;">
                                        <i class="fa fa-calendar"></i>
                                        {{event.date | date:'dd-MM-YYYY HH:mm'}}
                                    </p>
                                </div>
                                <p class="time-text mb-0 abs" *ngIf="event.application.newCompany.id != event.application.parentCompany.id">{{event.date | timeLeft}}</p>
                            </div>
                        </a>
                    </div>
                    <!-- <div class="dropdown-footer" *ngIf="events.length > 0">
                        <a href="#" class="dropdown-item">Ver todas</a>
                    </div> -->
                </div>
            </li>
            <li class="nav-item dropdown profile-nav-item">
                <a class="nav-link dropdown-toggle" role="button" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <div class="menu-profile">
                        <span class="name"><em>{{saludar()}}<b>{{user.firstName}}</b>!</em></span>
                        <img src="{{user.imageUrl}}" class="rounded-circle" alt="image">
                    </div>
                </a>
                <div class="dropdown-menu" [class.show]="showMenu">
                    <div class="dropdown-header d-flex flex-column align-items-center">
                        <div class="figure mb-3">
                            <img src="{{user.imageUrl}}" class="rounded-circle" alt="image">
                        </div>
                        <div class="info text-center">
                            <span class="name">{{user.firstName + ' ' + user.lastName}}</span>
                            <p class="mb-3 email">{{user.mail}}</p>
                        </div>
                    </div>
                    <div class="dropdown-body">
                        <ul class="profile-nav p-0 pt-3">
                            <li class="nav-item">
                                <a href="#" class="nav-link">
                                    <i class='bx bx-user'></i> <span>Perfil</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a routerLink="/select-company" class="nav-link">
                                    <i class='fa fa-building'></i> <span>Cambiar compania</span>
                                </a>
                            </li>
                            <!-- <li class="nav-item" *ngIf="show">
                                <a href="#" class="nav-link">
                                    <i class='bx bx-envelope'></i> <span>My Inbox</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a href="#" class="nav-link">
                                    <i class='bx bx-edit-alt'></i> <span>Editar Perfil</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a href="#" class="nav-link">
                                    <i class='bx bx-cog'></i> <span>Configuración</span>
                                </a>
                            </li> -->
                        </ul>
                    </div>
                    <div class="dropdown-footer">
                        <ul class="profile-nav">
                            <li class="nav-item">
                                <a href="#" (click)="logout()" class="nav-link">
                                    <i class='bx bx-log-out'></i> <span>Cerrar Sesión</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</nav>
<!-- End Top Navbar Area -->